module.exports = "<div class=\"app-footer navbar-fixed-bottom\">\n  <div class=\"wrapper b-t bg-light\">\n    <span class=\"pull-right\"> 1.2.4 - {{backendStatus}}</span>\n    Pysix Cloud by Tenacity &copy; {{year}}\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/page-footer/page-footer.component.html
// module id = ../../../../../src/app/page-footer/page-footer.component.html
// module chunks = main